import React from 'react'
import { useTransition, animated, SpringConfig } from 'react-spring'

export const Transition = ({
  fromStyles,
  toStyles,
  children,
  config,
}: {
  fromStyles: object
  toStyles: object
  children: any
  config?: SpringConfig
}) => {
  const transitions = useTransition(children, null, {
    from: fromStyles,
    enter: toStyles,
    leave: fromStyles,
    config,
  })

  return (
    <>
      {transitions.map(({ item, props, key }) =>
        item ? (
          <animated.div style={props} key={key}>
            {children}
          </animated.div>
        ) : null
      )}
    </>
  )
}
